import { render, staticRenderFns } from "./PrjRoute.vue?vue&type=template&id=eb9865cc&"
import script from "./PrjRoute.vue?vue&type=script&lang=ts&"
export * from "./PrjRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports